<template>
  <div class="indexBox">
    <div class="indexBack bg">
      <img class="hgd_mapBack" src="../assets/hgd_mapBack.png" />
      <div class="atlasmain" id="atlasmain"></div>
    </div>
  </div>
</template>
<!-- 引入jquery -->
<script src="https://code.jquery.com/jquery-3.2.1.min.js"></script>
//
<script type="text/javascript">
import * as echarts from "echarts";
export default {
  data() {
    return {
      //  graphArr: {
      //    "nodes": [{
      //        "id": "0",
      //        "name": "思政课程",
      //        "symbolSize": 60,
      //        "x": '',
      //        "y": '',
      //        "symbol": 'image://https://wlzj2.posedu.com.cn/school_76/uploads/20240716/9d6d4329fbf44c381e1b00e0b39cc654.png',
      //        "category": 0,
      //      }, {
      //        "id": "1",
      //        "name": "习近平新时代中国特色社会主义思想概论",
      //        "symbolSize": 20,
      //        "x": '',
      //        "y": '',
      //        "symbol": 'image://https://wlzj2.posedu.com.cn/school_76/uploads/20240716/9d6d4329fbf44c381e1b00e0b39cc654.png',
      //        "category": 0,
      //      },
      //      {
      //        "id": "2",
      //        "name": "形势与政策",
      //        "symbolSize": 20,
      //        "x": '',
      //        "y": '',
      //        "category": 0
      //      }, {
      //        "id": "3",
      //        "name": "中国近代史纲要",
      //        x: '',
      //        y: '',
      //        "symbolSize": 20,
      //        "category": 0
      //      }, {
      //        "id": "4",
      //        "name": "马克思主义基本原理",
      //        x: '',
      //        y: '',
      //        "symbolSize": 20,
      //        "category": 0
      //      },
      //      {
      //        "id": "5",
      //        "name": "思想道德与法治",
      //        x: '',
      //        y: '',
      //        "symbolSize": 20,
      //        "category": 0
      //      },
      //      {
      //        "id": "6",
      //        "name": "思想政治理论实践课",
      //        x: '',
      //        y: '',
      //        "symbolSize": 20,
      //        "category": 0
      //      },
      //      {
      //        "id": "7",
      //        "name": "毛泽东思想和中国特色社会主义理论体系概论",
      //        x: '',
      //        y: '',
      //        "symbolSize": 20,
      //        "category": 0,
      //        subset: [{
      //          name: '第一章1.1中国为什么选择马克思主义',
      //          id: '7-1',
      //        }, {
      //          name: '第一章1.2毛泽东为什么提出马克思主义的命题',
      //          id: '7-2',
      //        }, {
      //          name: '第一章1.3如何评价毛泽东和毛泽东思想的历史地位',
      //          id: '7-3',
      //        }, {
      //          name: '第四章2.1如何理解新民主主义革命总路线的具体内容',
      //          id: '7-4',
      //        }, ],
      //      },
      //      {
      //        "id": "8",
      //        "name": "大思政课",
      //        x: '',
      //        y: '',
      //        "symbolSize": 80,
      //        "category": 0,
      //        subset: [{
      //          name: '第一章思政课',
      //          id: '8-1',
      //        }, {
      //          name: '第二章思政课',
      //          id: '8-2',
      //        }, {
      //          name: '第三章思政课',
      //          id: '8-3',
      //        }, {
      //          name: '第四章思政课',
      //          id: '8-4',
      //        }, ],
      //      },
      //      {
      //        "id": "9",
      //        "name": "精神谱系",
      //        x: '',
      //        y: '',
      //        "symbolSize": 60,
      //        "category": 0
      //      },
      //      {
      //        "id": "10",
      //        "name": "强国建设",
      //        x: '',
      //        y: '',
      //        "symbolSize": 60,
      //        "category": 0
      //      },
      //      {
      //        "id": "11",
      //        "name": "齐齐哈尔大学深入“大国重器” 开展“大思政课”实践教学活动",
      //        x: 126.540530,
      //        y: 49.052270,
      //        "symbolSize": 20,
      //        "category": 4
      //      }, {
      //        "id": "12",
      //        "name": "哈尔滨工业大学从东方红一号到神舟",
      //        x: 130.605470,
      //        y: 44.276670,
      //        "symbolSize": 20,
      //        "category": 4
      //      }, {
      //        "id": "13",
      //        "name": "哈尔滨工业大学走进中国天眼",
      //        x: 123.925780,
      //        y: 52.402420,
      //        "symbolSize": 20,
      //        "category": 4
      //      }, {
      //        "id": "14",
      //        "name": "科技牵手农业，这些哈工大学生",
      //        x: 126.342770,
      //        y: 50.233150,
      //        "symbolSize": 20,
      //        "category": 4
      //      }, {
      //        "id": "15",
      //        "name": "智启北大荒，科技兴农梦”思政实践团",
      //        x: 123.706050,
      //        y: 46.437860,
      //        "symbolSize": 20,
      //        "category": 4
      //      }, {
      //        "id": "16",
      //        "name": "珍宝岛革命烈士陵园",
      //        x: 134.274900,
      //        y: 47.931070,
      //        "symbolSize": 20,
      //        "category": 3
      //      }, {
      //        "id": "17",
      //        "name": "哈尔滨工业大学航天馆",
      //        x: 132.681880,
      //        y: 45.912940,
      //        "symbolSize": 20,
      //        "category": 3
      //      }, {
      //        "id": "18",
      //        "name": "侵华日军第七三一部队罪证陈列馆",
      //        x: 130.803220,
      //        y: 44.048120,
      //        "symbolSize": 20,
      //        "category": 3
      //      }, {
      //        "id": "19",
      //        "name": "瑷珲历史陈列馆",
      //        x: 126.914060,
      //        y: 45.305800,
      //        "symbolSize": 20,
      //        "category": 3
      //      }, {
      //        "id": "20",
      //        "name": "中国一重集团有限公司",
      //        x: 124.277340,
      //        y: 46.634350,
      //        "symbolSize": 20,
      //        "category": 3
      //      }, {
      //        "id": "21",
      //        "name": "中国科学院国家天文台FAST观测基地",
      //        x: 123.332520,
      //        y: 47.442950,
      //        "symbolSize": 20,
      //        "category": 3
      //      },
      //      {
      //        "id": "22",
      //        "name": "范峰",
      //        x: 123.332520,
      //        y: 47.442950,
      //        "symbolSize": 20,
      //        "category": 3
      //      },
      //    ],
      //    "links": [{
      //      "source": "0",
      //      "target": "1"
      //    }, {
      //      "source": "0",
      //      "target": "2"
      //    }, {
      //      "source": "0",
      //      "target": "3"
      //    }, {
      //      "source": "0",
      //      "target": "4"
      //    }, {
      //      "source": "0",
      //      "target": "5"
      //    }, {
      //      "source": "0",
      //      "target": "6"
      //    }, {
      //      "source": "0",
      //      "target": "7"
      //    }, {
      //      "source": "6",
      //      "target": "14"
      //    }, {
      //      "source": "12",
      //      "target": "13"
      //    }, {
      //      "source": "7",
      //      "target": "11"
      //    }, {
      //      "source": "14",
      //      "target": "7-4"
      //    }, ],
      //    "categories": [{
      //      "name": "大思政课",
      //      "color": '#FB3820',
      //    }, {
      //      "name": "高校号",
      //      "color": '#FF8C00',
      //    }, {
      //      "name": "企业号",
      //      "color": '#FF7700',
      //    }, {
      //      "name": "基地号",
      //      "color": '#FF9D00',
      //    }, {
      //      "name": "实践案例",
      //      "color": '#FFDB01',
      //    }, {
      //      "name": "实践师资",
      //      "color": '#FFBF00',
      //    }, ]
      //  },
      graphArr: {},
      myoption: null,
      subset: 0, //展开的课程数
      myChart: null, //图表实例
    };
  },
  mounted() {
    this.$get("getFrontData", "")
      .then((res) => {
        console.log("res", res);
        this.graphArr = res.data;
        var chartDom = document.getElementById("atlasmain");
        console.log("chartDom", chartDom);
        this.myChart = echarts.init(chartDom);
        this.echartsLoad();
        this.myChartFun();
      })
      .catch((err) => {});
  },
  methods: {
    echartsLoad() {
      let that = this;
      this.myChart.showLoading();
      console.log("this.graphArr", this.graphArr);
      this.myChart.hideLoading();

      this.myoption = {
        title: {},
        tooltip: {
          //  show: false // 不显示 tooltip
        },
        //  grid: {
        //    top: 0,
        //    left: 0,
        //    right: 0,
        //    bottom: 0,
        //    containLabel: true
        //  },
        legend: [
          {
            // selectedMode: 'single',
            data: this.graphArr.categories.map(function (a) {
              return {
                name: a.name,
                itemStyle: {
                  color: a.color,
                },
              };
            }),
            itemGap: 30, // 设置图例块之间的间距
            textStyle: {
              color: "#ffffff", // 修改图例文字颜色
            },
            // 核心配置：默认只选中第一个（可自定义指定某一个）
            selected: (() => {
              const selectedObj = {};
              const categories = this.graphArr.categories;
              if (categories && categories.length > 0) {
                // 1. 遍历所有 categories，默认全部设为 false（取消选中）
                categories.forEach((item) => {
                  selectedObj[item.name] = false;
                });
                // 2. 将目标图例设为 true（选中），这里以「第一个」为例
                // 若要选中指定某一个，可改为：selectedObj['目标图例名称'] = true;
                selectedObj[categories[0].name] = true;
              }
              return selectedObj;
            })(),
          },
        ],
        animationDuration: 1500,
        animationEasingUpdate: "quinticInOut",
        series: [
          {
            name: "",
            type: "graph",
            legendHoverLink: false,
            draggable: true, // 允许节点拖动
            layout: "none", // force使用力导向布局
            //   force: {
            //     repulsion: 20 // 设置斥力
            //   },
            zoom: 1,
            data: this.graphArr.nodes.map(function (a) {
              console.log("a111", a);
              a.itemStyle = {
                color: that.graphArr.categories[a.category].color,
              };
              a.x = a.x && a.x != "" ? a.x : that.myXfun("x");
              a.y = a.y && a.y != "" ? a.y : that.myXfun("y");
              a.pid = a.pid ? a.pid : null; // 保留 pid 属性
              return {
                ...a,
              };
            }),
            links: this.graphArr.links,
            categories: this.graphArr.categories,
            roam: true, //是否可缩放和移动
            label: {
              position: "right",
              show: true,
              color: "#ffffff",
              formatter: function (params) {
                let pidname =
                  params.name.length > 25
                    ? params.name.slice(0, 25) + "..."
                    : params.name; // 限制为最多25个字
                let name =
                  params.name.length > 8
                    ? params.name.slice(0, 8) + "..."
                    : params.name; // 限制为最多8个字
                return `{${params.data.pid ? "highlight" : "normal"}|${
                  params.data.pid ? pidname : name
                }}`; // 使用富文本格式
              },
              rich: {
                highlight: {
                  fontSize: 10,
                  padding: [7, 5],
                  backgroundColor: "rgba(255, 255, 255, 0.3)",
                  borderRadius: 6,
                },
                normal: {
                  fontSize: 12,
                  padding: [0, 0],
                  backgroundColor: "rgba(0,0,0, 0)",
                  borderRadius: 0,
                },
              },
            },
            lineStyle: {
              color: "#ffffff",
              curveness: 0.2, //线条弧度
              opacity: 0.7, //透明度
              width: 0.5, // 线宽
            },
            emphasis: {
              focus: "adjacency",
              lineStyle: {
                width: 2,
                opacity: 1, //透明度
              },
            },
          },
        ],
        //  graphic: {
        //    type: 'rect',
        //    shape: {
        //      x: 120.535030, // 矩形的 x 坐标
        //      y: 42.800080, // 矩形的 y 坐标
        //      width: 200, // 矩形的宽度
        //      height: 300 // 矩形的高度
        //    },
        //    style: {
        //      fill: 'rgba(255, 255, 255, 0.7)', // 透明白色
        //      stroke: 'black', // 边框颜色
        //      lineWidth: 1 // 边框宽度
        //    }
        //  },
      };
      this.myChart.setOption(this.myoption);

      //  this.myoption && this.myChart.setOption(this.myoption);
    },
    myXfun(type) {
      if (type == "x") {
        // 差值6
        let numx = Math.random() * 18 + 1;
        return 133.89844275856967 + numx / 3;
      } else {
        // 差值5
        let numy = Math.random() * 15 + 1;
        return 40.51596558023873 + numy / 3;
      }
    },
    //  所有事件监听
    myChartFun() {
      let that = this;
      // 点击事件
      this.myChart.on("click", function (params) {
        console.log("params", params);
        if (params.data.subset && params.data.subset.length > 0) {
          if (that.subset.index == 0) {
            that.nodesNewlyFun(params);
          } else {
            if (that.subset.id == params.data.id) {
              that.nodesDelFun();
            } else {
              that.graphArr.nodes.splice(-that.subset.index, that.subset.index);
              that.nodesNewlyFun(params);
            }
          }
        } else {
          //点击发消息
          console.log("点击锚点的url", params.data.url);
          if (params.data.url) {
            parent.window.location.href = params.data.url;
            //  window.location.href = url;
            //  window.parent.location.href = url; //让父页面一起跳转
          }
          //  window.parent.postMessage({
          //    type: 'customMessage',
          //    content: params.data
          //  }, '*');
        }
      });
      //  监听点击空白事件
      this.myChart.getZr().on("click", function (params) {
        if (!params.target && that.subset.index > 0) {
          console.log("点击空白params", params);
          that.nodesDelFun();
        }
      });

      // 拖拽事件
      let draggedNodeId = null;
      let offsetX = 0;
      let offsetY = 0;

      this.myChart.on("mousedown", function (params) {
        if (params.dataType === "node") {
          draggedNodeId = params.data.id; // 记录当前拖动的节点

          // 计算鼠标与节点中心的偏移量
          const node = params.data;
          //  console.log("node", node);
          const pointInPixel = that.myChart.convertToPixel(
            {
              seriesIndex: 0,
              xAxisIndex: 0,
            },
            [node.x, node.y]
          );
          // console.log("pointInPixel", pointInPixel);
          offsetX = params.event.offsetX - pointInPixel[0];
          offsetY = params.event.offsetY - pointInPixel[1];
        }
      });

      this.myChart.on("mouseup", function () {
        draggedNodeId = null; // 清空拖动节点
        console.log("拖拽结束", that.graphArr.nodes);
      });
      //  console.log("this.myChart", this.myChart);
      this.myChart.on("mousemove", function (params) {
        if (draggedNodeId) {
          const newPosition = that.myChart.convertFromPixel(
            {
              seriesIndex: 0,
              xAxisIndex: 0,
            },
            [params.event.offsetX - offsetX, params.event.offsetY - offsetY]
          );
          //  console.log("newPosition", newPosition);
          that.myChart.dispatchAction({
            type: "updateGraphic",
            id: draggedNodeId,
            position: newPosition, // 更新节点位置
          });
        }
      });

      // 监听窗口大小变化
      window.addEventListener("resize", function () {
        // this.myChart.resize();
      });
    },
    //  删除展开的节
    nodesDelFun() {
      this.graphArr.nodes.splice(-this.subset.index, this.subset.index);
      console.log("this.graphArr.nodes删除", this.graphArr.nodes);
      this.subset = {
        index: 0,
        id: 0,
      };
      this.echartsLoad();
    },
    //  新增展开的节
    nodesNewlyFun(params) {
      console.log("新增展开的节params", params.data.x, params.data.symbolSize);
      this.subset = {
        index: params.data.subset.length,
        id: params.data.id,
      };
      for (let i = 0; i < params.data.subset.length; i++) {
        this.graphArr.nodes.push({
          ...params.data.subset[i],
          pid: params.data.id,
          x: Number(params.data.x) + 0.0125 * params.data.symbolSize,
          y: Number(params.data.y) + 0.5 * (i + 1),
          symbolSize: 6,
          draggable: false,
          category: params.data.category,
        });
      }
      console.log("this.graphArr.nodes", this.graphArr.nodes);
      this.echartsLoad();
    },
  },
};
</script>

<style scoped></style>
<style type="text/css">
.bg {
  background-position: 0 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.indexBox {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.indexBack {
  width: 100vw;
  height: 96.73vh;
  padding: 3.27vh 0 0;
  background-image: url(../assets/hgd_Back.png);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  /* background-color: green; */
}

.hgd_mapBack {
  width: 83.48%;
  height: 65.22%;
  position: absolute;
  bottom: 2.25%;
}

.atlasmain {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue